import { CURRENT_DOMAIN } from '@/config/env';
import { url as domainOrgin } from '@/config/site';

export const obj2string = (params = {}) => {
    const arr = [];
    Object.keys(params).forEach((key) => {
        arr.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
    });
    return arr.join('&');
};

export const toSmallCamel = (params = {}) => Object.fromEntries(Object.entries(params).map(([key, value]) => {
    const newKey = key.replace(/_(.)/g, (_, c) => c.toUpperCase());
    // 这里就不去递归转key了，暂时没需求
    return [newKey, value];
}));

/**
 * 解析 URL 白名单属性
 *
 * @param  {Object} data 数据源
 * @return {Object}
 */
export const parseUrlProps = (data = {}) => {
    const mapping = {};
    const props = [
        'href',
        'origin',
        'protocol',
        'port',
        'host',
        'hostname',
        'search',
        'hash',
        'pathname',
    ];
    props.forEach((key) => {
        mapping[key] = data[key] || '';
    });

    return mapping;
};

/**
 * 解析链接字符为对象
 *
 * @param  {string} url 链接
 * @return {Object}
 */
export const parseUrl = (url = '') => {
    try {
        return new URL(url);
    } catch (e) {
        const a = document.createElement('a');
        a.href = url;
        return parseUrlProps(a);
    }
};

/**
 * 解析帮助链接
 *
 * @param {string} currentLocale 当前语种，默认 en
 * @param  {string} id 链接id
 * @param {string} path 跳转页面路径，默认为用户中心文章页
 * @return {Object}
 */
export const helpCenterUrl = (currentLocale = 'en', id = '', path = '/help-center/bybitHC_Article') => {
    const { hostname } = window.location;
    const isTestnet = window.sfe?.env === 'testnet';
    const isProd = window.sfe?.env === 'prd' && hostname !== 'www.bycloud.org';
    const hasDomain = (isTestnet || isProd) ? '' : domainOrgin;
    const localesMap = {
        en: 'en',
        // 'en-US': 'en_US', // 下架美式英语
        'en-HK': 'en_HK',
        // 'zh-CN': 'zh_CN', 下架简体中文（合规化）
        'zh-MY': 'zh_MY', // 中文（马来西亚）
        'zh-HK': 'zh_HK',
        'zh-TW': 'zh_TW',
        'ja-JP': 'ja',
        'ru-RU': 'ru',
        'es-ES': 'es',
        'vi-VN': 'vi',
        'tr-TR': 'tr',
        'pt-BR': 'pt_BR',
        // 'fr-FR': 'fr', 下架法语（合规化）
        'th-TH': 'th',
        'id-ID': 'in',
        'fil-PH': 'tl',
        // 'hi-IN': 'hi', 下架印地语
        'kk-KZ': 'kk',
        'uk-UA': 'uk',
        'pt-PT': 'pt_BR',
        'es-AR': 'es',
        'es-419': 'es',
        'es-MX': 'es',
        'ar-sa': 'en',
        'nl-NL': 'nl_NL',
        'en-NL': 'en_NL',
        'pl-PL': 'pl_PL',
        'ro-RO': 'ro_RO',
        'kk-KAZ': 'kk-KAZ',
        'ru-KAZ': 'ru-KAZ',
        'en-KAZ': 'en-KAZ',
        'tr-TUR': 'tr-TUR',
        'en-EU': 'en-EU',
        'pl-POL': 'pl-POL',
        'ro-ROU': 'ro-ROU',
        'es-ESP': 'es-ESP',
        'pt-PRT': 'pt-PRT',
    };
    const locale = currentLocale === 'pt-PT' ? 'pt-BR' : currentLocale;
    const url = `${hasDomain}/${locale}${path}?language=${localesMap[locale]}&id=${id}`;

    return {
        url,
        open(target = '_blank') {
            window.open(url, target);
        },
    };
};

/**
 * 替换链接的主域为当前 location.hostname 的主域
 *
 * @param {string} url 需要替换的 url
 * @return {string} 替换后的 url
 */
export const replaceDomainToLocation = (url) => {
    // domainReg 解释
    // 匹配 url 中协议后面的第一个 `/` 或者 第一个`:端口号/` 前面的两个域。比如：
    // https://www.bybit.com/a 匹配到 bybit.com
    // https://m.www.bybit.com/a 匹配到 bybit.com
    // https://m.www.bybit.com:8080/a 匹配到 bybit.com
    // https://m.www.bybit-m.com:8080/a 匹配到 bybit-m.com
    const domainReg = /(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?){2}(?=(?::\d+)?\/)/;
    return url.replace(domainReg, `.${CURRENT_DOMAIN}`);
};

/**
 * 设置链接host
 *
 * @return {string}
 */
export const setDomain = () => {
    const { hostname } = window.location;
    const isTestnet = window.sfe?.env === 'testnet';
    const isProd = window.sfe?.env === 'prd' && hostname !== 'www.bycloud.org';
    if (process.env.NODE_ENV === 'production') {
        return (isTestnet || isProd) ? '' : domainOrgin;
    }

    return domainOrgin;
};

/**
 * 设置不带域名链接
 *
 * @param {string} url 链接
 * @return {string}
 */
export const noDmainUrl = (url = '') => `${setDomain()}${url}`;
